import { apis } from '@doltech/core/lib/api/api.config';
import { getUserAnonymousId } from '@doltech/core/lib/auth/constants';
import { isEqualIgnoreCaseTrim } from '@doltech/utils/lib/text';
import { flow, types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

import { showToast } from '../../Toast';
import { ImageInfoStore } from '../AdminForm/vocab-list-input.store';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

const riddleStatisticInitial = {
  noOfCorrectSelections: 0,
  noOfIncorrectSelections: 0,
};

export const submitRiddleProgress = async (id, payload) => {
  const { data } = await apis.publicOnlineTestV2.post(
    apiPublicUrls.onlineTestV2.DAILY_LEARNING_RIDDLE_PROGRESS,
    { ...payload, sessionId: getUserAnonymousId() },
    {
      params: { id },
    }
  );
  return data;
};

export const RiddleStatistic = t.model('RiddleStatistic', riddleStatisticInitial);

export const RiddleCardStore = t
  .model('RiddleCardStore', {
    id: t.string,
    question: t.string,
    correctAnswer: t.string,
    image: t.maybeNull(ImageInfoStore),
    userAnswer: t.maybeNull<any>(t.string),
    isSubmitted: t.optional(t.boolean, false),
    statistics: t.optional(RiddleStatistic, riddleStatisticInitial),

    isSubmitting: t.optional(t.boolean, false),
  })
  .views((self) => ({
    get isUserAnswerCorrect() {
      return isEqualIgnoreCaseTrim(self.userAnswer, self.correctAnswer);
    },
  }))
  .actions((self) => ({
    submitRiddle: flow(function* submitRiddleProgressFn() {
      self.isSubmitting = true;
      try {
        const res = yield submitRiddleProgress(self.id, {
          userAnswer: self.userAnswer,
        });
        self.statistics = res.statistic;
      } catch (ex) {
        showToast({
          icon: 'error',
          title: ex.message,
        });
      }

      self.isSubmitting = false;
    }),
  }))
  .actions((self) => ({
    userDontKnow() {
      self.userAnswer = '';
      self.isSubmitted = true;
      self.submitRiddle();
    },
    setUserAnswer(value) {
      self.userAnswer = value;
    },
    checkUserAnswer() {
      self.isSubmitted = true;
      self.submitRiddle();
    },
  }));

export const useRiddleCardStore = () => {
  return useStore(RiddleCardStore);
};

export const withRiddleCardStore = (Component: any) => (props: any) => {
  const { data } = props;
  const newData = { ...data };
  if (data.userAnswer && data.userAnswer.trim().length > 0) {
    newData.isSubmitted = true;
  }
  const riddleCreateStore = useCreateStore(RiddleCardStore, newData);
  const RiddleCardStoreProvider = useProvider(RiddleCardStore);

  return (
    <RiddleCardStoreProvider value={riddleCreateStore}>
      <Component {...props} />
    </RiddleCardStoreProvider>
  );
};
